export default __webpack_public_path__ + "static/media/carousel-1.2875ad72.png";